var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-pdf-icon';
                    var viewUrl = 'gfx/sprite.svg#view-icon-pdf-icon';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };